'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleId = exports.cache = exports.styleTag = exports.options = undefined;

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _uniq = require('lodash/uniq');

var _uniq2 = _interopRequireDefault(_uniq);

var _sortBy = require('lodash/sortBy');

var _sortBy2 = _interopRequireDefault(_sortBy);

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _createRules = require('./create-rules');

var _createRules2 = _interopRequireDefault(_createRules);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var options = exports.options = {
  autoAttach: true
};
var styleTag = exports.styleTag = null;
var cache = exports.cache = {};

var styleId = exports.styleId = (0, _utils.hashed)((0, _utils.randomHex)());

var createStyleTag = function createStyleTag() {
  exports.styleTag = styleTag = styleTag || document.getElementById(styleId);
  if (!styleTag) {
    exports.styleTag = styleTag = document.createElement('style');
    styleTag.id = styleId;
    document.head.appendChild(styleTag);
  }
  return styleTag.sheet;
};

var cxsync = function cxsync() {
  for (var _len = arguments.length, rest = Array(_len), _key = 0; _key < _len; _key++) {
    rest[_key] = arguments[_key];
  }

  var style = _merge2.default.apply(undefined, [{}].concat(rest));
  var hashname = (0, _utils.hashed)(JSON.stringify(style));
  if (cache[hashname]) return hashname;

  var classNames = [];
  var rules = (0, _createRules2.default)(hashname, style);

  rules.forEach(function (r) {
    cache[r.id] = r;
  });

  rules.filter(_utils.propertyFilter).forEach(function (r) {
    return classNames.push(r.selector.replace(/^\./, ''));
  });

  if (options.autoAttach) cxsync.attach();

  return (0, _uniq2.default)(classNames).join(' ');
};

cxsync.attach = function () {
  if (!(0, _utils.hasDocument)()) return;

  var sheet = createStyleTag();
  var selectors = [].slice.call(sheet.cssRules).map(function (r) {
    return r.selectorText;
  });

  cxsync.rules.filter(function (_ref) {
    var selector = _ref.selector;
    return selectors.indexOf(selector) === -1;
  }).forEach(function (_ref2) {
    var css = _ref2.css;

    try {
      sheet.insertRule(css, sheet.cssRules.length);
    } catch (e) {}
  });
};

cxsync.clearCache = function () {
  exports.cache = cache = {};
};

Object.defineProperty(cxsync, 'rules', {
  get: function get() {
    return (0, _sortBy2.default)((0, _filter2.default)(cache, function (v) {
      return !!v && v.css.length;
    }), ['order']);
  }
});

Object.defineProperty(cxsync, 'css', {
  get: function get() {
    return cxsync.rules.map(function (r) {
      return r.css;
    }).join('');
  }
});

exports.default = cxsync;